import { render, staticRenderFns } from "./Day16.vue?vue&type=template&id=0fafa91e"
import script from "./Day16.vue?vue&type=script&lang=js"
export * from "./Day16.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports